import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import Select from 'react-select';


const RecordAddLicense = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [record, setRecord] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [states, setStates] = useState(null);
    const [state, setState] = useState(null);
        


    useEffect(() => {

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getStates();

        const license_no = searchParams.get("license_no");
        let issue_date = searchParams.get("issue_date");
        issue_date = Date.parse(issue_date);

        if (isNaN(issue_date) == false) {
            var dt = new Date(issue_date);
            const year = dt.getFullYear();
            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
            const day = dt.getDate().toString().padStart(2, "0");

            issue_date = month + '/' + day + '/' + year
        }
        else {
            issue_date = null;
        }
        let expiry_date = searchParams.get("expiry_date");
        expiry_date = Date.parse(expiry_date);
        if (isNaN(expiry_date) == false) {
            var dt = new Date(expiry_date);
            const year = dt.getFullYear();
            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
            const day = dt.getDate().toString().padStart(2, "0");
            expiry_date = month + '/' + day + '/' + year
        }
        else {
            expiry_date = null;
        }

        const issued_by = searchParams.get("issued_by");
        const other_info = searchParams.get("other_info");
        const state_id = searchParams.get("state_id");
        const state_name = searchParams.get("state_name");
        setRecord({
            ...record,
            identity: license_no,
            issue_date: issue_date,
            expiry_date: expiry_date,
            issued_by: issued_by,
            other_info: other_info,
            state_id:state_id,
            state_name:state_name,
            
        })




    }, []);



    const getStates = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-states", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setStates(response?.data?.states);



                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }


    const saveRecord = (event) => {

        if (!record?.identity || !record?.expiry_date || !record?.issued_by) {
            Swal.fire({ icon: "error", title: "Please enter required date", text: "License No., Expiry Date and Issued By is required. Please enter required data." });

            return false;
        }
        setIsBtn(true);
        axios.post(process.env.REACT_APP_API_URL + "/save-record", {
            category: "license",
            identity: record?.identity,
            issue_date: record?.issue_date,
            expiry_date: record?.expiry_date,
            issued_by: record?.issued_by,
            other_info: record?.other_info,
            state_id: record?.state_id,
            file_name:searchParams.get("file_name"),
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "License Record", text: "Successfully added." });
                    setRecord({
                        ...record,
                        identity: "",
                        issue_date: "",
                        expiry_date: "",
                        issued_by: "",
                        other_info: "",
                    });
                    navigate("/records");
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if(error.status==403)  navigate("/login")
else
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }




    const backToRecords = async (e) => {
        navigate("/records")
    };



    return (
        <>
            <div className="title-box">
                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToRecords} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Add to Records</h3>
                <div className="flex-equal justify-content-end" >

                </div>

            </div>

            <div className="box" >

                <div className="form-content" >


                    <div className="input-container" >
                        <label >License Number</label>

                        <input type="text"  id="identity"
                            name="identity" value={record?.identity}
                            onChange={(e) => setRecord({ ...record, identity: e.target.value })}
                        />


                    </div>
                    <div className="input-container" >
                        <label >Issued By</label>

                        <input type="text"  id="issued_by"
                            name="issued_by" value={record?.issued_by}
                            onChange={(e) => setRecord({ ...record, issued_by: e.target.value })}
                        />


                    </div>

                    <div className="input-container" >
                        <label >Issue Date</label>
                        <DatePicker
                            id="issue_date"
                            name="issue_date"
                             value={record?.issue_date}
                             showYearDropdown={true}
                            selected={record?.issue_date}
                            onChange={(e) => {
                                var dt = new Date(e);

                                const year = dt.getFullYear();
                                const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                const day = dt.getDate().toString().padStart(2, "0");

                                const formatted_date = month + '/' + day + '/' + year
                                setRecord({ ...record, issue_date: formatted_date })

                            }}
                            onSelect={(e) => {
                                var dt = new Date(e);

                                const year = dt.getFullYear();
                                const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                const day = dt.getDate().toString().padStart(2, "0");

                                const formatted_date = month + '/' + day + '/' + year
                                setRecord({ ...record, issue_date: formatted_date })

                            }}
                        />


                    </div>

                    <div className="input-container" >
                        <label >Expiry Date</label>
                        <DatePicker   
                        showYearDropdown={true}
                            id="expiry_date"
                            name="expiry_date" value={record?.expiry_date}
                            selected={record?.expiry_date}
                            onChange={(e) => {
                                var dt = new Date(e);

                                const year = dt.getFullYear();
                                const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                const day = dt.getDate().toString().padStart(2, "0");

                                const formatted_date = month + '/' + day + '/' + year
                                setRecord({ ...record, expiry_date: formatted_date })

                            }}
                            onSelect={(e) => {
                                var dt = new Date(e);

                                const year = dt.getFullYear();
                                const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                const day = dt.getDate().toString().padStart(2, "0");

                                const formatted_date = month + '/' + day + '/' + year
                                setRecord({ ...record, expiry_date: formatted_date })

                            }}
                        />
                    </div>

                    
                    <div className="input-container" >
                        <label >State</label>
                        <Select
                                className="react-select" classNamePrefix="react-select"
                                cacheOptions
                                options={states}
                                placeholder=""
                                value={{ "value": record?.state_id, "label": record?.state_name }}
                                onChange={(e) => setRecord({ ...record, state_id: e.value,state_name:e.label })}
                                noOptionsMessage={({ inputValue }) => !inputValue ? "Start Typing" : "No results found"}
                            />

                    </div>


                    <div className="input-container" >
                        <label >Other Information</label>
                        <input type="text"  id="other_info"
                            name="other_info" value={record?.other_info}
                            onChange={(e) => setRecord({ ...record, other_info: e.target.value })}
                        />
                    </div>
                </div>

              


            </div>


            <div className="form-action">

<div className="action-bar ">

    <div className="button-box">

        <button className="btn btn-secondary" type="button" onClick={backToRecords}>Cancel</button>
        <button className="btn btn-primary" onClick={saveRecord} disabled={isBtn}>
            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>

    </div>
</div>

</div>



        </>


    );
};

export default RecordAddLicense;